
import { IntlProvider } from 'react-intl';
import ReactDOM from 'react-dom';
import React from 'react';
import '../Root.scss';
import './Welcome.scss';
import SignIn from '../util/SignIn.jsx';
import GameListing from '../Home/GameListing.jsx';

export default function FeaturedPage() {
    return (
        <div className="welcome" >
            <div>
                <div className="title">
                    <h1> Glorbex Sports Exchange </h1>
                </div>
            </div>
            <div className="fade-light" />
            <div className="text" >
                <h4> How Good Are You at Predicting the Next Score? </h4>
            </div>
            <div className="text">
                <SignIn />
            </div>
            <div className="text">
                <h1> How&apos;s it work? </h1>
                <h2> Bet on the next major event in the game</h2>
            </div>
            <div className="fade-dark" />
            <div className="bottom-container">
                <GameListing readOnly={true} />
            </div>
        </div>
    );
}

// create a named function to the ReactDOM.render function
const render = () => ReactDOM.render(
    <IntlProvider locale="en">
        <FeaturedPage />
    </IntlProvider>,
    document.getElementById('react-root')
);

render();
